<template>
  <v-card>

    <v-card-title>
      {{ $t('rights.addForm.title') }}
    </v-card-title>


    <v-card-text class="mt-4">

      <v-card class="droparea"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }">
        <v-card-text>
          <v-row class="d-flex flex-column" dense align="center" justify="center">
            <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
              mdi-cloud-upload
            </v-icon>
            <p>
              {{ $t('rights.addForm.drop_links_here') }}
            </p>
          </v-row>
          <v-virtual-scroll
            v-if="spotifyLinks.length > 0"
            :items="spotifyLinks"
            height="150"
            item-height="50"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn @click.stop="removeLink(item)" icon>
                    <v-icon> mdi-close-circle </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card-text>
        <v-card-text class="d-flex">
          <v-spacer></v-spacer>
          <template v-if="spotifyLinks.length">
            {{ spotifyLinks.length + ' ' + $t('rights.addForm.num_links') }}
          </template>
        </v-card-text>
      </v-card>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text color="primary" @click="onSave" :disabled="!spotifyLinks.length">{{ $t('rights.addForm.save') }}</v-btn>
      <v-spacer/>
      <v-btn text color="secondary" @click="cancel">{{ $t('app.cancel') }}</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>

export default {
  name: "AddRightSpotifyForm",
  data() {
    return {
      dragover: false,
      spotifyLinks: []
    }
  },

  computed: {
  },

  methods: {

    onSave() {
      this.$emit('save', this.spotifyLinks)
    },

    cancel() {
      this.$emit('cancel');
    },

    removeLink(link) {
      const index = this.spotifyLinks.findIndex(e => e === link)
      if (index > -1) this.spotifyLinks.splice(index, 1)
    },

    onDrop(e) {
      this.dragover = false;
      try {
        const links = e.dataTransfer.getData("text").split('\n')
        const validRe = /^https:\/\/open.spotify.com\//i
        links.forEach(element => {
          if (validRe.test(element)) {
            this.spotifyLinks.push(element)
          }
        })
      } catch (error) {
        //
      }
    }
  }
}
</script>

<style scoped>
.droparea {
  min-height: 250px !important;
  background-color: rgba(0, 0, 0, 0.1) !important;
}
</style>
